import { render, staticRenderFns } from "./SafetyQuestions.vue?vue&type=template&id=660e2dd9&"
import script from "./SafetyQuestions.vue?vue&type=script&lang=js&"
export * from "./SafetyQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports